import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

export const useGetMe = () => {
  const { toast } = useToast()

  const {
    data,
    isError,
    isLoading,
    refetch: refetchMe,
  } = useQuery({
    queryKey: ['me'],
    queryFn: () => usersService.getMe(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados do usuário',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      user: data.user,
      isLoading,
      refetchMe,
    }
  }

  return {
    user: null,
    isLoading,
    refetchMe,
  }
}
